import { render, staticRenderFns } from "./TradeShows.vue?vue&type=template&id=4e0b129e&"
import script from "./TradeShows.vue?vue&type=script&lang=js&"
export * from "./TradeShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports